import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { FormattedMessage } from "react-intl";
import { GeneralUtils } from "../utils";
import { LocalizationMessages } from "../localization/messages";
import { UserContextActionCreators } from "../redux/action-creators";
import { UserContextSelectors } from "../redux/selectors";
import { SessionUpdateInterval } from "../constants";

const SessionTime = () => {
  const dispatch = useDispatch();
  const sessionTime = useSelector(UserContextSelectors.sessionTime);
  const [formattedSessionTime, setFormattedSessionTime] = useState("");

  useEffect(() => {
    const startSessionTimeTask = () =>
      dispatch(UserContextActionCreators.startSessionTimeTask());

    const stopSessionTimeTask = () =>
      dispatch(UserContextActionCreators.stopSessionTimeTask());

    const timeout = setTimeout(startSessionTimeTask, SessionUpdateInterval);

    return () => {
      stopSessionTimeTask();
      clearTimeout(timeout);
    };
  }, [dispatch]);

  useEffect(() => {
    setFormattedSessionTime(GeneralUtils.getFormattedSessionTime(sessionTime));
  }, [sessionTime]);

  return (
    <span>
      <FormattedMessage {...LocalizationMessages.sessionTime} />{" "}
      {formattedSessionTime}
    </span>
  );
};

export default React.memo(SessionTime);
